import { render, staticRenderFns } from "./noticeConfig.vue?vue&type=template&id=562cbfe2&scoped=true&"
import script from "./noticeConfig.vue?vue&type=script&lang=js&"
export * from "./noticeConfig.vue?vue&type=script&lang=js&"
import style0 from "./noticeConfig.vue?vue&type=style&index=0&id=562cbfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562cbfe2",
  null
  
)

export default component.exports